import Vue from 'vue'
import VueRouter from 'vue-router'
import { isUserLoggedIn } from '@/auth/utils';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */'@/views/Home.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Accueil',
      },
    },
    {
      path: '/entreprise',
      name: 'entrepriseLogin',
      component: () => import(/* webpackChunkName: "manager" */'@/views/entreprise/Login.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Inscription Entreprise',
      },
    },
    {
      path: '/entreprise/pre-enregistrement',
      name: 'entreprisePreRegistration',
      component: () => import(/* webpackChunkName: "manager" */'@/views/entreprise/PreRegistration.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Pré-enregistrement',
      },
    },
    {
      path: '/entreprise/convention/:hash',
      name: 'entrepriseConvention',
      component: () => import(/* webpackChunkName: "manager" */'@/views/entreprise/Convention.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signature Convention',
      },
    },
    {
      path: '/entreprise/signature-terminee',
      name: 'entrepriseSignatureTerminee',
      component: () => import(/* webpackChunkName: "manager" */'@/views/entreprise/Signed.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signature Terminée',
      },
    },
    
    {
      path: '/banque',
      name: 'pmcaLogin',
      component: () => import(/* webpackChunkName: "manager" */'@/views/pmca/Login.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Connexion Banque',
      },
    },
    {
      path: '/banque/pre-enregistrement',
      name: 'pmcaPreRegistration',
      component: () => import(/* webpackChunkName: "manager" */'@/views/pmca/PreRegistration.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Pré-enregistrement',
      },
    },
    {
      path: '/banque/convention/:hash',
      name: 'pmcaConvention',
      component: () => import(/* webpackChunkName: "manager" */'@/views/pmca/Convention.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signature Convention',
      },
    },
    {
      path: '/banque/signature-terminee',
      name: 'pmcaSignatureTerminee',
      component: () => import(/* webpackChunkName: "manager" */'@/views/pmca/Signed.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signature Terminée',
      },
    },

    {
      path: '/cgu',
      name: 'termsAndConditions',
      component: () => import(/* webpackChunkName: "manager" */'@/views/TermsAndConditions.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Conditions Générales d\'Utilisation',
      },
    },
    {
      path: '/mentions-legales',
      name: 'legalTerms',
      component: () => import(/* webpackChunkName: "manager" */'@/views/LegalTerms.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Mentions Legales',
      },
    },
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */'@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: '404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  // Redirect to login if not logged in
  if (![
    'home',
    'pmcaLogin',
    'pmcaConvention',
    'pmcaSignatureTerminee',
    'entrepriseLogin',
    'entrepriseConvention',
    'entrepriseSignatureTerminee',
    'legalTerms',
    'termsAndConditions',
    '404',
  ].includes(to.name) && !isLoggedIn) {
    return next("/")
  }

  document.title = `Inscription Securact - ${to.meta.pageTitle}`

  return next()
})

export default router